import { Outlet } from "react-router";
import logoIcon from "@/assets/transparentLogo.png";
import logoText from "@/assets/logoText.png";

export default function AuthLayout() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="relative hidden bg-muted lg:block">
        <img
          src={logoText}
          alt="Unique Medicos"
          className="absolute inset-0 h-full w-full object-contain px-20"
        />
      </div>
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-end gap-2">
          <a href="login" className="flex items-center gap-2 font-medium">
            <div className="flex h-6 w-6 items-center justify-center">
              <img src={logoIcon} alt="icon" className="h-full w-full" />
            </div>
            <span className="mb-0.5">Unique Medicos</span>
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
